import { configureStore } from "@reduxjs/toolkit";

import templeReducer from "./templeSlice";
import planReducer from "./planSlice";
import authReducer from "./authSlice";

export const store = configureStore({

  reducer: {

    temples: templeReducer,

    plan: planReducer,

    auth: authReducer

  }

});